import { render, staticRenderFns } from "./SrcResultComponent.vue?vue&type=template&id=67554c60&scoped=true&"
import script from "./SrcResultComponent.vue?vue&type=script&lang=ts&"
export * from "./SrcResultComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SrcResultComponent.vue?vue&type=style&index=0&id=67554c60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67554c60",
  null
  
)

export default component.exports